import { render, staticRenderFns } from "./imgL.vue?vue&type=template&id=36e27013"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36e27013')) {
      api.createRecord('36e27013', component.options)
    } else {
      api.reload('36e27013', component.options)
    }
    module.hot.accept("./imgL.vue?vue&type=template&id=36e27013", function () {
      api.rerender('36e27013', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholdersNew/imgL.vue"
export default component.exports